import { Type, Static } from '@sinclair/typebox';

// Login request schema
export const LoginRequestSchema = Type.Object({
  emailOrUsername: Type.String({
    minLength: 1,
    maxLength: 255,
    description: 'Email адрес или username пользователя',
  }),
  password: Type.String({
    minLength: 1,
    description: 'User password',
  }),
  remember_me: Type.Optional(
    Type.Boolean({
      default: false,
      description: 'Whether to create persistent session',
    })
  ),
});

// Login response schema
export const LoginResponseSchema = Type.Object({
  success: Type.Boolean(),
  user: Type.Optional(
    Type.Object({
      id: Type.Number(),
      email: Type.String(),
      name: Type.String(),
      username: Type.Union([Type.String(), Type.Null()]),
      roles: Type.Array(Type.String()), // Массив role_code из identity_roles
      last_login_at: Type.Optional(Type.Union([Type.String({ format: 'date-time' }), Type.Date()])),
      email_verified_at: Type.Optional(
        Type.Union([Type.String({ format: 'date-time' }), Type.Date()])
      ),
      is_active: Type.Boolean(),
      avatar_thumb_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
      avatar_medium_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    })
  ),
  session_token: Type.Optional(Type.String()),
  expires_at: Type.Optional(Type.String({ format: 'date-time' })),
  error: Type.Optional(Type.String()),
});

// Logout request schema
export const LogoutRequestSchema = Type.Object({
  session_token: Type.Optional(
    Type.String({
      description: 'Session token to invalidate (optional if using cookies)',
    })
  ),
});

// Logout response schema
export const LogoutResponseSchema = Type.Object({
  success: Type.Boolean(),
  message: Type.Optional(Type.String()),
});

// Current user response schema
export const CurrentUserResponseSchema = Type.Object({
  user: Type.Optional(
    Type.Object({
      id: Type.Number(),
      email: Type.String(),
      name: Type.String(),
      username: Type.Union([Type.String(), Type.Null()]),
      roles: Type.Array(Type.String()), // Массив role_code из identity_roles
      last_login_at: Type.Optional(Type.Union([Type.String({ format: 'date-time' }), Type.Date()])),
      email_verified_at: Type.Optional(
        Type.Union([Type.String({ format: 'date-time' }), Type.Date()])
      ),
      is_active: Type.Boolean(),
      avatar_thumb_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
      avatar_medium_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
    })
  ),
  authenticated: Type.Boolean(),
});

// Password change request schema
export const ChangePasswordRequestSchema = Type.Object({
  current_password: Type.String({
    minLength: 1,
    description: 'Current password for verification',
  }),
  new_password: Type.String({
    minLength: 8,
    maxLength: 255,
    description: 'New password',
  }),
});

// TypeScript types derived from schemas
export type LoginRequest = Static<typeof LoginRequestSchema>;
export type LoginResponse = Static<typeof LoginResponseSchema>;
export type LogoutRequest = Static<typeof LogoutRequestSchema>;
export type LogoutResponse = Static<typeof LogoutResponseSchema>;
export type CurrentUserResponse = Static<typeof CurrentUserResponseSchema>;
export type ChangePasswordRequest = Static<typeof ChangePasswordRequestSchema>;
